// @ts-nocheck

/** @type {WeakMap<Element, SidebarOverlay>} */
const sidebarOverlayMap = new WeakMap();

/**
 *
 * @param {HTMLElement} element
 * @returns {SidebarOverlay | undefined}
 */
export function getSidebarOverlayFromElement(element) {
    return sidebarOverlayMap.get(element);
}

// Продолжительность движения сайдбара в секундах при открытии/закрытии
const sidebarTransformTransitionDuration = 0.3;

export class SidebarOverlay {
    /**
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        sidebarOverlayMap.set(element, this);

        /** @type {HTMLElement} */
        this.element = element;
        this.element.style.setProperty(
            "--transform-transition-duration",
            `${sidebarTransformTransitionDuration}s`,
        );

        /** @type {boolean} */
        this.isOpen = false;

        /** @type {number | undefined} */
        this.visibilityTimeoutId = undefined;

        // Закрытие сайдбара при клике на элемент с атрибутом data-sidebar-overlay-close
        element
            .querySelectorAll("[data-sidebar-overlay-close]")
            .forEach((closeEl) => {
                if (closeEl instanceof HTMLElement) {
                    closeEl.addEventListener("click", () => this.close());
                }
            });

        /**
         * Задник для сайдбара
         * @type {HTMLElement}
         */
        this.backdrop = document.createElement("div");
        this.backdrop.setAttribute("data-sidebar-overlay-backdrop", "");
        // Закрытие сайдбара при клике на задник
        this.backdrop.addEventListener("click", () => this.close());
        this.element.after(this.backdrop);
    }

    open() {
        if (this.isOpen) {
            return;
        }
        clearTimeout(this.visibilityTimeoutId);
        this.isOpen = true;
        this.element.dataset.visibility = "visible";
        this.element.dataset.open = this.isOpen.toString();
        this.backdrop.dataset.visibility = "visible";
    }

    close() {
        if (!this.isOpen) {
            return;
        }
        this.isOpen = false;
        this.visibilityTimeoutId = setTimeout(() => {
            this.element.dataset.visibility = "hidden";
        }, sidebarTransformTransitionDuration * 1000);
        this.element.dataset.open = this.isOpen.toString();
        this.backdrop.dataset.visibility = "hidden";
    }
}
